import '../anonymous.css'

import React from 'react'

import { AnonymousWrapper, AppHeaderContainer } from '../index'

function NoAccess() {
  const { t: translate } = useTranslation()

  return (
    <AnonymousWrapper>
      <AppHeaderContainer />
      <div className="anonymous-page_image">
        <img src="images/lock.svg" alt="" />
      </div>
      <div className="anonymous-page_message">
        <h2>{translate('noAccess.message')}</h2>
        <p>{translate('noAccess.hint')}</p>
      </div>
      <div className="anonymous-page_button">
        <button type="button">{translate('noAccess.help')}</button>
      </div>
    </AnonymousWrapper>
  )
}

export default NoAccess
